import styled from 'styled-components';

export const InfoBlockContent = styled.div`
  color: var(--color-text);
`;
